import React from 'react';
import {BrowserRouter as Router, Redirect, Route, Switch, withRouter} from 'react-router-dom';
import * as authenticationAction from '../actions/authenticateActions'
export const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route {...rest} render={props => (
       (authenticationAction.isAuthenticated()===true)
            ? <Component {...props} />
            : <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
    )} />
)